import { useWindowSize } from 'hooks';
import { Modal } from 'components';

import { CartProducts } from 'components/gifts-table/ShoppingCart';

export default function ListGiftsRecived({ show, onClose, ...props }) {
  const [, { isMobile }] = useWindowSize();
  return (
      <Modal
        show={show}
        onClose={onClose}
        withActionButtons={false}
        contentClassName={!isMobile?'px-0 pt-0 pb-3':'px-0 pt-1 border-top'}
        centered={isMobile}
        variant="completed"
        titleHeader={isMobile && 'Bolsa de regalos'}
        showBack={isMobile}
      >
        <CartProducts {...props} variant="big" />
      </Modal>
  );
}
